import { render, staticRenderFns } from "./whatsapp-templates.vue?vue&type=template&id=62ade3aa&scoped=true"
import script from "./whatsapp-templates.vue?vue&type=script&lang=js"
export * from "./whatsapp-templates.vue?vue&type=script&lang=js"
import style0 from "./whatsapp-templates.vue?vue&type=style&index=0&id=62ade3aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ade3aa",
  null
  
)

export default component.exports